import styled from 'styled-components';
import COLORS from 'utils/constants/COLORS';

export const StyledInput = styled.input`
  border: none;
  font-family: "SourceSansPro-Regular", Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #151515;
  padding-left: 15px;
  width: 100% !important;
  font-weight: 600;
  height: 32px;
`;

export const StyledPasswordInput = styled(StyledInput)`
  -webkit-text-security: ${(props) => (props.show ? 'value' : 'disc')} !important;
  &::-ms-reveal,
  &::-ms-clear {
    display: none;
  }

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
  }

  &[type='number'] {
    -moz-appearance: textfield; /* Firefox */
  }
`;

export const StyledShowPasswordButton = styled.button`
  background-color: white;
  border: none;
  outline: none;
  cursor: pointer;
  color: ${COLORS.primary} !important;
`;
